import { cloneElement } from "react";
import Button from "./Button"; // Certifique-se de que este import está correto

const FilterForm = ({ autoCompleteFields, onSubmit, onClear }) => {
  return (
    <form
      className="form-row px-2 py-3 rounded shadow-sm mb-2 theme-background d-flex align-items-center"
      onSubmit={onSubmit}
    >
      {autoCompleteFields.map(
        ({ label, component, gridSize = "12" }, index) => {
          const gridClass = gridSize ? `col-md-${gridSize}` : "col-md-6";

          return (
            <div className={`form-group ${gridClass} mb-2`} key={index}>
              {cloneElement(component, { label })}
            </div>
          );
        },
      )}

      <div className="col-md-12 d-flex justify-content-start align-items-center p-0 mt-2">
        <div className="d-flex gap-2">
          <Button
            type="submit"
            text="Filtrar"
            className="btn btn-blue-light fw-semibold"
          />
          <Button
            type="button"
            text="Limpar filtros"
            className="btn btn-blue-light fw-semibold"
            onClick={onClear}
          />
        </div>
      </div>
    </form>
  );
};

export default FilterForm;
